module.exports = __webpack_public_path__ + "img/index_y1.e0d1facd.png";